import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	getFilterTopics,
	setFilterTopic,
	toggleFilterSections,
	resetFilterTopics,
} from '../../../../redux/actions';
import { Checkbox, Dropdown, Icon, Loader } from '../../../../components';
import colors from '../../../../utils/colors';

function Topics() {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const [topicFilter, setTopicFilter] = useState(new RegExp('', 'gi'));

	const topics = state.filter.topics;
	const selected = state.filter.selected;

	const handleFilterList = (value, callback) => {
		if (value.match(/[a-z0-9]/gi) !== null) {
			callback(new RegExp(value.match(/[a-z0-9]/gi).join(''), 'gi'));
		} else {
			callback(new RegExp(''));
		}
	};

	const handleTaskCount = (topic) => {
		//return 0 if tasks doesnt exist or empty
		if (!topic.pytania || topic.pytania.length <= 0) return 0;

		//get all tasks from topic
		let tasks = topic.pytania;

		// TODO: filter tasks by selected taskType

		// filter tasks by selected difficulty - temporary hidden
		// tasks = tasks.filter(task => selected.difficulty.includes(task['poziom_zakres']));

		return tasks.length;
	};

	useEffect(() => {
		/* TODO: delete selected.subject.length after api update */
		// if (selected.subjects && selected.subjects.length > 0) {
		//     dispatch(getFilterTopics(state.user, selected.level, selected.classes, selected.subjects[0], selected.taskType));
		// }
		if (selected.level && selected.subjects.length > 0) {
			dispatch(getFilterTopics(state.user, selected.level, selected.classes, selected.subjects));
		} else {
			dispatch(resetFilterTopics());
		}
		// dispatch(resetFilterSelectedTopics());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected.level, selected.classes, selected.subjects]);

	return (
		<Dropdown
			className="topics-dropdown"
			title="dostępne tematy"
			name="topics"
			isOpen={state.filter.activeSections.indexOf('topics') !== -1}
			onClick={() => {
				setTopicFilter(new RegExp(''));
				dispatch(toggleFilterSections('topics'));
			}}
		>
			<div className="dropdown-input">
				<input
					placeholder="Wyszukaj temat"
					onChange={(e) => handleFilterList(e.target.value, setTopicFilter)}
				/>
				<Icon name="search" color={colors.greyDark} width="13" height="13" />
			</div>
			<ul className="dropdown-list" onClick={() => {}}>
				{state.filter.loadingSections.includes('topics') ? (
					<li className="loader-container">
						<Loader type="ellipsis" />
					</li>
				) : topics.length > 0 ? (
					topics
						.filter((topic) => topic.temat.match(topicFilter))
						.map((topic) => (
							<li className="dropdown-list-item" key={topic['temat_id']}>
								<Checkbox
									id={topic['temat_id']}
									label={topic.temat}
									checked={selected.topics.includes(topic['temat_id'])}
									onChange={() => {
										dispatch(setFilterTopic(topic['temat_id']));
									}}
								/>
								<span className="checkbox-results-counter">{`(${handleTaskCount(topic)})`}</span>
							</li>
						))
				) : (
					<li className="dropdown-list-item">Brak</li>
				)}
			</ul>
		</Dropdown>
	);
}

export default Topics;
